
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import TopBarSection from "@/components/Reusable/AppLayout/TopBar/TopBarSection.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import Icon from "@/components/UI/Icon.vue";
import { DesignProvider } from "@/types/design-library";

@Component({
  components: {
    Icon,
    Dropdown,
    TopBarSection
  }
})
export default class DesignProviderDropdown extends Vue {
  @Prop()
  value!: DesignProvider | null;

  @Prop()
  providers!: DesignProvider[];

  open = false;
  search = "";

  @Watch("search")
  onSearchChange() {
    const scrollable = this.$refs.scrollable as Vue & {
      $el: HTMLDivElement;
    };

    this.$nextTick(() => {
      scrollable.$el.scrollTop = 0;
    });
  }

  get filteredProviders() {
    if (!this.search) return this.providers;

    return this.providers.filter(provider =>
      provider.name.toLowerCase().includes(this.search.toLowerCase())
    );
  }

  chooseProvider(provider: DesignProvider) {
    this.$emit("input", provider);
    this.open = false;
  }
}
